// extracted by mini-css-extract-plugin
export default {"host":"style_host__+wOUl","loading":"style_loading__BM1Vq"};